/** Client-side Google Maps API key (Vite env). Never commit real keys to git. */
export function getGoogleMapsApiKey(): string | undefined {
  const raw = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
  if (typeof raw !== 'string') return undefined;
  const trimmed = raw.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

export const GOOGLE_MAPS_SETUP_HINT =
  'Set VITE_GOOGLE_MAPS_API_KEY in the matching .env file (.env.development, .env.staging, or .env.production), enable Maps JavaScript API and Geocoding API in Google Cloud, then rebuild.';
